module.exports = __webpack_public_path__ + "static/media/Subtract.ff7d04fb.svg";